export const initialState = {};

export function reducer(state, action) {
  switch (action.type) {
    case 'OnInitDocumentTypeWithAllowedStates':
      return OnInitDocumentTypeWithAllowedStates(state, action);
    case 'OnInitAuthorization':
      return onInitAuthorization(state, action);
    case 'OnInitUserGroups':
      return onInitUserGroups(state, action);
    case 'OnInitChangedRefinePermissions':
      return OnInitChangedRefinePermissions(state, action);
    case 'OnInitDisabledSave':
      return OnInitDisabledSave(state, action);
    case 'OnSetAuthorizationXDocumentTypeXUserGroupValue':
      return onSetAuthorizationXDocumentTypeXUserGroupValue(state, action);
    case 'OnRefineSetAll':
      return onSetRefineAll(state, action);
    case 'OnSaveAuthorizationXDocumentTypeXUserGroups':
      return onSaveAuthorizationXDocumentTypeXUserGroups(state);
    case 'OnResetChangedRefinePermission':
      return onResetChangedRefinePermission(state);
    default:
      return state;
  }
}

function OnInitDocumentTypeWithAllowedStates(state, action) {
  return {
    ...state,
    documentTypeWithAllowedStates: action.documentTypeWithAllowedStates
  };
}

function onInitAuthorization(state, action) {
  return {
    ...state,
    authorization: action.authorization
  };
}

function onInitUserGroups(state, action) {
  return {
    ...state,
    userGroups: action.userGroups
  };
}

function OnInitChangedRefinePermissions(state, action) {
  return {
    ...state,
    changedRefinePermissions: action.changedRefinePermissions
  };
}

function OnInitDisabledSave(state, action) {
  return {
    ...state,
    disabledSave: action.disabledSave
  };
}

function onSetAuthorizationXDocumentTypeXUserGroupValue(state, action) {
  const { userGroupId, documentStateId, value, documentTypeId } = action;
  let changedRefinedPermissionOnDocumentStateId =
    state.changedRefinePermissions[documentTypeId] !== undefined
      ? state.changedRefinePermissions[documentTypeId][documentStateId]
      : undefined;
  return {
    ...state,
    disabledSave: false,
    changedRefinePermissions: {
      ...state.changedRefinePermissions,
      [documentTypeId]: {
        ...state.changedRefinePermissions[documentTypeId],
        [documentStateId]: {
          ...changedRefinedPermissionOnDocumentStateId,
          documentStateId: documentStateId,
          [userGroupId]: value
        },
        documentTypeId
      }
    }
  };
}

function onSetRefineAll(state, action) {
  const userGroups = state.userGroups;
  const { documentStateId, documentTypeId, value } = action;

  const documentTypeIdChangedPermissions = state.changedRefinePermissions[documentTypeId];
  let authorizationRefineChangedPermissions = {};
  if (documentTypeIdChangedPermissions !== undefined) {
    authorizationRefineChangedPermissions = state.changedRefinePermissions[documentTypeId][documentStateId] || {};
  }
  let changed = false;
  userGroups.forEach(userGroup => {
    if (!changed) {
      if (
        authorizationRefineChangedPermissions[userGroup.id] === undefined ||
        authorizationRefineChangedPermissions[userGroup.id] !== value
      ) {
        changed = true;
      }
    }
    authorizationRefineChangedPermissions[userGroup.id] = value;
  });
  return changed
    ? {
        ...state,
        disabledSave: false,
        changedRefinePermissions: {
          ...state.changedRefinePermissions,
          [documentTypeId]: {
            ...state.changedRefinePermissions[documentTypeId],
            [documentStateId]: {
              ...authorizationRefineChangedPermissions,
              documentStateId: documentStateId
            },
            documentTypeId
          }
        }
      }
    : state;
}

function onSaveAuthorizationXDocumentTypeXUserGroups(state) {
  return {
    ...state,
    disabledSave: true
  };
}

function onResetChangedRefinePermission(state) {
  return {
    ...state,
    changedRefinePermissions: {}
  };
}
